import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    CircularProgress,
    Container,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Stack,
    Divider,
    IconButton,
    Tooltip,
    TextField,
    InputAdornment,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";
import { Delete, Search, Send } from "@mui/icons-material";
import axios from "axios";
import { ENDPOINT } from "../../../endpoints/endpoints";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NotiList = () => {
    const [devices, setDevices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    // 🔔 Broadcast form state
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [sending, setSending] = useState(false);

    // ---------------- Fetch Devices ----------------
    const fetchDevices = async (query = "") => {
        setLoading(true);
        try {
            const token = localStorage.getItem("accessToken");
            const url = query
                ? `${ENDPOINT.FCM_DEVICE_LIST}?search=${encodeURIComponent(query)}`
                : ENDPOINT.FCM_DEVICE_LIST;

            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setDevices(res.data.data || []);
        } catch (error) {
            console.error("Error fetching devices:", error);
            toast.error("Failed to fetch device list");
        } finally {
            setLoading(false);
        }
    };

    // ---------------- Broadcast Send ----------------
    const handleBroadcast = async () => {
        if (!title || !body) {
            toast.warning("Please enter both title and body");
            return;
        }

        try {
            setSending(true);
            const token = localStorage.getItem("accessToken");

            const res = await axios.post(
                ENDPOINT.FCM_BROADCAST_SEND,
                { title, body },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data.success) {
                toast.success(` ${res.data.message}`);
            } else {
                toast.warning(res.data.message);
            }

            // reset form + reload device list
            setTitle("");
            setBody("");
            fetchDevices();
        } catch (error) {
            console.error("Broadcast failed:", error);

            // ✅ Backend error message ထုတ်ပြမယ်
            const errorMsg =
                error.response?.data?.message || 
                error.response?.data?.detail ||  
                // "Something went wrong while sending notification.";

            toast.error(`${errorMsg}`);
        } finally {
            setSending(false);
        }

    };

    // ---------------- Delete ----------------
    const openDeleteDialog = (id) => {
        setDeleteId(id);
        setOpenDialog(true);
    };

    const closeDeleteDialog = () => {
        setDeleteId(null);
        setOpenDialog(false);
    };

    // const handleDelete = async () => {
    //     try {
    //         const token = localStorage.getItem("accessToken");
    //         await axios.delete(`${ENDPOINT.FCM_DEVICE_LIST}${deleteId}/delete/`, {
    //             headers: { Authorization: `Bearer ${token}` },
    //         });
    //         toast.success("Device deleted successfully!");
    //         fetchDevices(search);
    //     } catch (error) {
    //         console.error("Delete failed:", error);
    //         toast.error("Failed to delete device");
    //     } finally {
    //         closeDeleteDialog();
    //     }
    // };

    // ---------------- Search ----------------
    const handleSearch = (e) => {
        e.preventDefault();
        fetchDevices(search);
    };

    // ---------------- On Mount ----------------
    useEffect(() => {
        fetchDevices();
    }, []);

    // ---------------- UI ----------------
    return (
        <Container maxWidth="lg" sx={{ mt: 5 }}>
            <ToastContainer position="top-right" autoClose={3000} />

            {/* ===================================================== */}
            {/* 📢 Broadcast Form */}
            {/* ===================================================== */}
            <Paper elevation={2} sx={{ p: 3, mb: 4, borderRadius: 3 }}>
                <Typography variant="h6" fontWeight="bold" mb={2}>
                    📢 Send Broadcast Notification
                </Typography>

                <Stack spacing={2}>
                    <TextField
                        label="Notification Title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Notification Body"
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        fullWidth
                        multiline
                        minRows={3}
                    />

                    <Box display="flex" justifyContent="flex-end">
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Send />}
                            onClick={handleBroadcast}
                            disabled={sending}
                            sx={{ textTransform: "none" }}
                        >
                            {sending ? "Sending..." : "Send Broadcast"}
                        </Button>
                    </Box>
                </Stack>
            </Paper>

            {/* ===================================================== */}
            {/* 🔍 Search + Device List */}
            {/* ===================================================== */}
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
            >
                <Typography variant="h6" fontWeight="bold">
                    🔔 Registered FCM Devices
                </Typography>

                {/* <Box component="form" onSubmit={handleSearch}>
                    <TextField
                        size="small"
                        placeholder="Search by email or token..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Search color="action" />
                                </InputAdornment>
                            ),
                        }}
                        sx={{ width: 280 }}
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ ml: 1, textTransform: "none" }}
                        disabled={loading}
                    >
                        Search
                    </Button>
                </Box> */}
            </Stack>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" p={5}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper elevation={3} sx={{ borderRadius: 3, overflow: "hidden" }}>
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ID</TableCell>
                                    {/* <TableCell>User Email</TableCell> */}
                                    <TableCell>Token</TableCell>
                                    <TableCell>Created At</TableCell>
                                    {/* <TableCell align="center">Actions</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {devices.length > 0 ? (
                                    devices.map((device, index) => (
                                        <TableRow key={device.id || index} hover>
                                            <TableCell>{index + 1}</TableCell>
                                            {/* <TableCell>{device.user_email || "—"}</TableCell> */}
                                            <TableCell sx={{ maxWidth: 320 }}>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                    {device.token}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {new Date(device.created_at).toLocaleString()}
                                            </TableCell>
                                            {/* <TableCell align="center">
                                                <Tooltip title="Delete Device">
                                                    <IconButton
                                                        color="error"
                                                        onClick={() => openDeleteDialog(device.id)}
                                                    >
                                                        <Delete fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell> */}
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ py: 4 }}>
                                            <Typography color="text.secondary">
                                                No registered devices found.
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Divider />
                    <Box
                        sx={{
                            p: 2,
                            backgroundColor: "#fafafa",
                            textAlign: "right",
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            Total Devices: <strong>{devices.length}</strong>
                        </Typography>
                    </Box>
                </Paper>
            )}

            {/* ===================================================== */}
            {/* 🗑️ Delete Confirmation Dialog */}
            {/* ===================================================== */}
            {/* <Dialog open={openDialog} onClose={closeDeleteDialog}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this device token?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeDeleteDialog} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="error" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog> */}
        </Container>
    );
};

export default NotiList;